import type { ByomModelInfo } from '../../../../api/client'
import { getImageModelAlias, getImageModelLabel } from '../../../../constants/modelAliases'

export interface ImageModelOption {
  value: string
  label: string
}

export function byomImageModelLabel(model: ByomModelInfo, fallbackLabel: string): string {
  return model.key_name || `${fallbackLabel} (${model.id.slice(-8)})`
}

export function buildImageModelOptions(
  nativeModelIds: string[],
  byomModels: ByomModelInfo[],
  fallbackNativeModelIds: string[],
  byomFallbackLabel: string,
): ImageModelOption[] {
  const nativeValues = nativeModelIds.length ? nativeModelIds : fallbackNativeModelIds
  return [
    ...byomModels
      .filter((model) => model.enabled)
      .map((model) => ({
        value: model.id,
        label: byomImageModelLabel(model, byomFallbackLabel),
      })),
    ...nativeValues.map((value) => ({ value, label: getImageModelLabel(value) })),
  ]
}

export function resolveImageModelDisplayLabel(
  modelId: string,
  options: ImageModelOption[],
  isUnavailable: boolean,
  unavailableLabel: string,
  fallbackLabel: string,
): string {
  if (isUnavailable) return unavailableLabel
  return getImageModelAlias(modelId)
    ?? options.find((option) => option.value === modelId)?.label
    ?? fallbackLabel
}
